<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin: 0 auto">
        <mt-header title>
          <router-link to slot="left">
            <mt-button icon="back" @click.native="$router.back(-1)"
              >个人资料</mt-button
            >
          </router-link>
        </mt-header>
        <div class="warning">请您填写真实信息</div>
        <!-- 步骤一 -->
        <div class="form">
          <div class="rolItem">
            <mt-field
              label="手机号码："
              class="inputTxt"
              type="number"
              v-model="user.mobile"
              placeholder="请输入手机号"
            ></mt-field>
            <div class="captchaBox">
              <mt-field
                label="验证码："
                placeholder="请输入验证码"
                v-model="captcha"
                class="inputCaptcha"
                :attr="{ maxlength: 6 }"
              ></mt-field>
              <mt-button
                type="primary"
                class="getcaptcha"
                @click="getCaptcha"
                v-if="sendAuthCode"
                >获取验证码</mt-button
              >
              <mt-button
                type="primary"
                class="getcaptcha"
                v-if="!sendAuthCode"
                :class="!sendAuthCode ? 'disableClass' : ''"
                >剩余{{ auth_time }}s</mt-button
              >
            </div>
          </div>
          <div class="rolItem" v-if="showInfo">
            <mt-field label="身份选择：" class="inputStyle" disabled>
              <input
                type="radio"
                id="doctor"
                :value="2"
                v-model="user.userType"
              />医生
              <input
                type="radio"
                id="normal"
                :value="1"
                v-model="user.userType"
              />患者
              <input
                type="radio"
                id="worker"
                :value="3"
                v-model="user.userType"
              />从业人员
            </mt-field>
          </div>
          <div class="rolItem" v-if="showInfo">
            <mt-field
              label="真实姓名："
              class="inputTxt"
              type="text"
              v-model="user.name"
              placeholder="请输入真实姓名"
            ></mt-field>
          </div>
          <div v-show="showInfo && user.userType === 2">
            <div class="rolItem">
              <mt-field label="所在地区：" class="inputStyle" disabled>
                <span @click="getPopup">{{
                  user.address || '请选择所在地区'
                }}</span>
              </mt-field>
              <div class="overlayer" @touchmove.prevent>
                <mt-popup
                  v-model="showBuyCourse"
                  position="bottom"
                  popup-transition="popup-fade"
                  fixed
                >
                  <div @click="getPopup" class="showPopup">完成</div>
                  <mt-picker
                    :slots="myAddressSlots"
                    @change="onMyAddressChange"
                    :visibleItemCount="5"
                    valueKey="areaName"
                  ></mt-picker>
                </mt-popup>
              </div>
              <!-- <addr :address="user.address" /> -->
            </div>
          </div>
          <div v-show="showInfo">
            <mt-field
              v-show="user.userType === 3 || user.userType === 2"
              label="工作单位："
              class="inputTxt"
              type="text"
              v-model="user.hospital"
              placeholder="请输入工作单位"
            ></mt-field>
          </div>
        </div>
        <div class="getBtn">
          <div v-if="!showInfo">
            <mt-button
              type="primary"
              class="btn"
              @click.native.prevent="regCaptchaNew()"
              >下一步</mt-button
            >
          </div>
          <div v-else>
            <mt-button
              type="primary"
              v-if="subType == '0'"
              class="btn"
              @click.native.prevent="regCaptchaOld()"
              >提交</mt-button
            >
            <mt-button
              type="primary"
              v-else
              class="btn"
              @click.native.prevent="regCaptchaOld()"
              >完善资料</mt-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { refreshToken } from '../../common/refreshToken'
import myaddress from '../../assets/json/address.json'
import addr from '../../components/areaSelect/index'
export default {
  components: { addr },
  data() {
    return {
      capt: true,
      radioDisabled: false,
      showInfo: false,
      captcha: '',
      sendAuthCode: true,
      auth_time: 0,
      user: {
        name: this.$route.query.name,
        userType: parseInt(this.$route.query.userType) || '',
        mobile: this.$route.query.mobile,
        address: this.$route.query.address,
        hospital: this.$route.query.hospital,
        isAuth: 2,
        cerLevel: '',
      },
      showBuyCourse: false,
      userInfo: {},
      userId: '',
      isShowAddress: false,
      myaddress: [],
      myAddressSlots: [
        {
          flex: 1,
          defaultIndex: 1,
          values: Object.keys(myaddress), //省份数组
          className: 'slot1',
          textAlign: 'center',
        },
        {
          flex: 1,
          values: [],
          className: 'slot3',
          textAlign: 'center',
        },
        {
          flex: 1,
          values: [],
          className: 'slot5',
          textAlign: 'center',
        },
      ],
      myAddressProvince: '',
      myAddressCity: '',
      myAddresscounty: '',
      submit: null,
    }
  },

  created() {
    this.subType = localStorage.getItem('subType')
      ? localStorage.getItem('subType')
      : 0
  },
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = sessionStorage.getItem('userId')
    this.setUserInfo()
    this.$nextTick(() => {
      //vue里面全部加载好了再执行的函数 （类似于setTimeout）
      this.myAddressSlots[0].defaultIndex = 0 // 这里的值需要和 data里面 defaultIndex 的值不一样才能够初始化 //因为我没有看过源码（我猜测是因为数据没有改变，不会触发更新）
    })
    this.noShare()
  },
  methods: {
    getPopup() {
      this.showBuyCourse = !this.showBuyCourse
      this.user.address =
        this.myAddressProvince +
        '-' +
        this.myAddressCity +
        '-' +
        this.myAddresscounty
    },
    goBack() {
      this.$router.go(-1)
    },
    closeShowAddress(e) {
      if (e.target == this.$refs.selectAddress) {
        this.isShowAddress = !this.isShowAddress
      }
    },
    onMyAddressChange(picker, values) {
      if (myaddress[values[0]]) {
        //这个判断类似于v-if的效果（可以不加，但是vue会报错，很不爽）
        picker.setSlotValues(1, Object.keys(myaddress[values[0]])) // Object.keys()会返回一个数组，当前省的数组
        picker.setSlotValues(2, myaddress[values[0]][values[1]]) // 区/县数据就是一个数组
        this.myAddressProvince = values[0]
        this.myAddressCity = values[1]
        this.myAddresscounty = values[2]
        this.user.address =
          this.myAddressProvince +
          '-' +
          this.myAddressCity +
          '-' +
          this.myAddresscounty
      }
    },
    //获取手机验证码
    getCaptcha() {
      if (!this.user.mobile) {
        this.$toast('请先输入手机号码')
        return
      }
      let mreg = /^1[0-9]{10}$/
      if (this.user.mobile.length <= 10 || !mreg.test(this.user.mobile)) {
        this.$toast('请输入正确的手机号')
        return this
      }
      this.$http({
        url: `/live/liveUsers/send/${this.user.mobile}`,
        method: 'get',
      }).then(({ data }) => {
        // this.$toast('验证码已发送')
      })
      this.sendAuthCode = false
      //设置倒计时秒
      this.auth_time = 60
      var auth_timetimer = setInterval(() => {
        this.auth_time--
        if (this.auth_time <= 0) {
          this.sendAuthCode = true
          clearInterval(auth_timetimer)
        }
      }, 1000)
    },
    //验证码校验
    regCaptchaOld() {
      let _this = this
      if (_this.capt) {
        if (!_this.captcha) {
          _this.$toast('验证码不能为空')
          return _this
        }
        _this
          .$http({
            url: `/live/liveUsers/check/${_this.user.mobile}/${_this.captcha}`,
            method: 'get',
          })
          .then(({ data }) => {
            if (data && data.code === 0) {
              _this.capt = false
              this.commitCertification()
            } else {
              _this.$toast(data.msg ? data.msg : '验证码错误')
              // this.captchaType = false
              return _this
            }
          })
      } else {
        _this.commitCertification()
      }
    },
    regCaptchaNew() {
      let _this = this
      if (!_this.captcha) {
        _this.$toast('验证码不能为空')
        return _this
      }
      _this
        .$http({
          url: `/live/liveUsers/check/${_this.user.mobile}/${_this.captcha}`,
          method: 'get',
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.capt = false // 已验证手机号，再不验证
            _this.showInfo = true
            this.getByMobileUser(_this.user.mobile)
          } else {
            _this.$toast(data.msg ? data.msg : '验证码错误')
            return _this
          }
        })
    },
    // 根据手机号获取用户信息
    getByMobileUser(mobile) {
      this.$http({
        url: `live/liveUsers/getUserInfoByMoblie/${mobile}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.user = data.data
          if (!this.user.userType || this.user.userType === 0) {
            this.user.userType = 2
          }
        } else {
          this.user = {
            name: this.$route.query.name,
            userType: parseInt(this.$route.query.userType) || 2,
            mobile: mobile,
            address: this.$route.query.address,
            hospital: this.$route.query.hospital,
            isAuth: 2,
            cerLevel: '',
          }
        }
      })
    },
    //获取用户信息做数据回显判断
    setUserInfo() {
      if (this.user) {
        if (this.user.mobile) {
          this.capt = true // 若手机号存在，验证手机号
          this.showInfo = true
        } else {
          this.showInfo = false
          this.capt = false
        }
        if (!this.user.userType || this.user.userType === 0) {
          this.user.userType = 2
        }
      } else {
        this.user = {
          name: this.$route.query.name,
          userType: parseInt(this.$route.query.userType) || 2,
          mobile: this.$route.query.mobile,
          address: this.$route.query.address,
          hospital: this.$route.query.hospital,
          isAuth: 2,
          cerLevel: '',
        }
        this.showInfo = false
      }
    },
    // 信息提交
    commitCertification() {
      const _this = this
      if (!_this.user.userType) {
        _this.$toast('用户身份不能为空')
        return _this
      }
      if (!_this.user.name) {
        _this.$toast('姓名不能为空')
        return _this
      }
      if (!_this.user.mobile) {
        _this.$toast('手机号不能为空')
        return _this
      }
      if (
        (_this.user.userType === 2 || _this.user.userType === 3) &&
        !_this.user.hospital
      ) {
        _this.$toast('工作单位不能为空')

        return _this
      }
      if (_this.user.userType === 2 && !_this.user.address) {
        _this.$toast('所在地区不能为空')
        return _this
      }
      const openId = sessionStorage.getItem('openId')
      sessionStorage.setItem('mobile', _this.user.mobile)
      _this
        .$http({
          url: '/live/liveUsers/updateInfo',
          method: 'put',
          data: {
            openId: openId,
            name: _this.user.name,
            gender: _this.user.gender,
            userType: _this.user.userType,
            mobile: _this.user.mobile,
            address: _this.user.userType == 2 ? _this.user.address : '',
            hospital:
              _this.user.userType == 2 || _this.user.userType == 3
                ? _this.user.hospital
                : '',
            cerLevel: _this.user.userType == 1 ? 1 : 2,
          },
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            refreshToken(_this).then((res) => {
              localStorage.setItem('userType', _this.user.userType)
              localStorage.setItem('subType', '1')
              _this.$toast('资料已提交')
              if (res.code == 0) {
                let returnUrl = _this.$route.query.returnUrl
                if (returnUrl) {
                  location.href = returnUrl
                } else {
                  _this.$router.go(-1)
                }
              }
            })
          } else {
            _this.$toast(data.msg)
          }
        })
    },
  },
}
</script>
<style lang='scss' scoped>
.showPopup {
  text-align: right;
  margin-right: 1rem;
  padding: 1rem 0;
  font-size: 18px;
}
/deep/ .mint-popup-bottom {
  width: 100%;
}
.inputCaptcha {
  flex: 0;
  width: 65%;
}
.rolItem {
  border-bottom: 10px solid #eee;
}
.inputStyle /deep/ .mint-field-core {
  flex: 0;
  padding: 0;
  width: 0;
}
.captchaBox {
  position: relative;
  .getcaptcha {
    position: absolute;
    top: 5px;
    right: 10px;
    line-height: 36px;
  }
}
.cerType {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem 1rem;
  // background-color: #eee;
  line-height: 2rem;
  color: green;
}
.red {
  color: #f00;
}
.getBtn {
  box-sizing: border-box;
  margin-top: 20px;
  height: 55px;
  padding: 0 1rem;
  padding-bottom: 1rem;
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.btn {
  width: 90%;
  height: 100%;
  font-size: $font-title;
  border-radius: 10px;
  line-height: 36px;
}
.btn:hover {
  color: #fff;
  text-decoration: none;
  border: none;
}
.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none;
}
.container {
  width: 100%;
  height: 100%;
  background: #fbfbfb;
}
.warning {
  text-align: center;
  padding: 1rem;
  background-color: #eee;
}
.disableClass {
  opacity: 0.6;
}
</style>
